type Callback = () => void;

class AudioPlayer {
  private static _instance: AudioPlayer;

  private audioElement: HTMLAudioElement;

  private isPlaying: boolean = false;

  private endedCallback?: Callback;

  private stopCallback?: Callback;

  private constructor() {
    this.audioElement = new Audio();
  }

  public static get instance(): AudioPlayer {
    if (!AudioPlayer._instance) {
      AudioPlayer._instance = new AudioPlayer();
    }

    return AudioPlayer._instance;
  }

  /**
   * 播放音频
   * @param url      音频资源地址
   * @param onEnded  播放自然结束时的回调
   * @param onStop   播放被 stop() 或新的 play() 中断时的回调
   */
  public play(url: string, onEnded?: Callback, onStop?: Callback): void {
    if (this.isPlaying) {
      this.stop();
    }

    this.audioElement.src = url;
    this.audioElement.currentTime = 0;
    this.audioElement.volume = 1;

    this.stopCallback = onStop;

    if (onEnded) {
      this.endedCallback = () => {
        onEnded();
        this.cleanup();
      };
      this.audioElement.addEventListener('ended', this.endedCallback);
    }

    this.audioElement.play();
    this.isPlaying = true;
  }

  /** 停止播放，触发当前音轨的 onStop 回调 */
  public stop() {
    if (this.stopCallback) {
      this.stopCallback();
    }
    this.cleanup();
    this.audioElement.pause();
    this.audioElement.currentTime = 0;
    this.isPlaying = false;
  }

  public getState() {
    return {
      src: this.audioElement.src,
      paused: this.audioElement.paused,
      ended: this.audioElement.ended,
      currentTime: this.audioElement.currentTime,
      duration: this.audioElement.duration
    };
  }

  private cleanup(): void {
    if (this.endedCallback) {
      this.audioElement.removeEventListener('ended', this.endedCallback);
      this.endedCallback = undefined;
    }
    this.stopCallback = undefined;
  }
}

export default AudioPlayer;
